import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { CardTypeComponent } from './card-type.component';
import { CardTypeDetailComponent } from './card-type-detail.component';
import { CardTypePopupComponent } from './card-type-dialog.component';
import { CardTypeDeletePopupComponent } from './card-type-delete-dialog.component';

import { Principal } from '../../shared';


export const cardTypeRoute: Routes = [
    {
        path: 'card-type',
        component: CardTypeComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.cardType.home.title'
        }
    }, {
        path: 'card-type/:id',
        component: CardTypeDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.cardType.home.title'
        }
    }
];

export const cardTypePopupRoute: Routes = [
    {
        path: 'card-type-new',
        component: CardTypePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.cardType.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'card-type/:id/edit',
        component: CardTypePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.cardType.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'card-type/:id/delete',
        component: CardTypeDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.cardType.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type.route.ts